var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analysis"},[_vm._m(0),_c('div',{staticClass:"container"},[_c('div',{staticClass:"home-container"},[_c('router-view',{staticClass:"iframe"})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("数据中心")])])
}]

export { render, staticRenderFns }